




import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { ICustomer, IProject, IMarkers } from '@/interfaces/data';
import store from '@/store';
import {
  SET_OVERLAY_DISPLAY,
  COPY_MARKERS_TO_TEMPMARKERS,
  SET_FILTERING_STATE_TO_DEFAULT,
  SET_FILTERING_ELEMENT_DISABLED,
  CHANGE_SLIDER_MODEL_VALUE,
  CHANGE_RADIO_GROUP_TEXT,
  CLEAR_TEMPMARKERS
} from '@/store/constants/mutation-types';

@Component
export default class AdminTreeView extends Vue {
  public $auth!: {
    token: string;
    isAuthenticated: boolean;
    isAdmin: boolean;
  };

  private treeViewItems = [];
  private treeModelValue = [];
  private treeViewModel = [];
  private treeViewModelCopy = [];

  @(namespace('ProjectModule').State('projects')) private projects!: IProject[];

  @(namespace('LocationModule').Mutation('deleteLocation'))
  private deleteLocation!: (projectId) => null;

  @(namespace('LocationModule').Action('requestAllLocationsForProject'))
  private requestAllLocationsForProject!: ({ token, projectId }) => Promise<{}>;

  @(namespace('LocationModule').Action('requestAllLocationsForCustomer'))
  private requestAllLocationsForCustomer!: ({
    token,
    customerId
  }) => Promise<{}>;

  @Prop()
  private map;

  @(namespace('CustomerModule').State('customers'))
  private customers!: ICustomer[];

  @(namespace('LocationModule').State('tempMarkers'))
  private tempMarkers!: IMarkers[];

  @(namespace('ProjectModule').Action('getProjects'))
  private getProjects!: (token) => Promise<{}>;

  @(namespace('CustomerModule').Action('getCustomers'))
  private getCustomers!: (token) => Promise<{}>;

  @(namespace('OverLayModule').State('overlayEnable'))
  private overlay;

  @(namespace('MarkersFilteringModule').State('radioGroup'))
  private radioGroup;

  @(namespace('MarkersFilteringModule').State('filterElementDisabled'))
  private filterElementDisabled;

  private coordinates = {
    type: 'FeatureColletion',
    crs: {
      type: 'name',
      properties: { name: 'urn:ogc:def:crs:OGC:1.3:CRS84' }
    },
    features: []
  };

  private onTreeModelPropertyChanged(items) {
    // if the tree view item is checked the array length will
    // be bigger than the previous length
    store.commit(`OverLayModule/${SET_OVERLAY_DISPLAY}`, true);
    console.log(this.overlay);
    if (this.treeViewModel.length > this.treeViewModelCopy.length) {
      items.map(async item => {
        if (!this.treeViewModelCopy.includes(item)) {
          if (item.startsWith('Project')) {
            await store.dispatch(
              'LocationModule/requestAllLocationsForProject',
              {
                token: this.$auth.token,
                projectId: item.slice(8)
              }
            );
            store.commit(`LocationModule/${COPY_MARKERS_TO_TEMPMARKERS}`);
            console.log(this.overlay);
          }
          store.commit(
            `MarkersFilteringModule/${SET_FILTERING_ELEMENT_DISABLED}`,
            false
          );
          store.commit(
            `MarkersFilteringModule/${CHANGE_RADIO_GROUP_TEXT}`,
            'all'
          );

          this.tempMarkers.map(location => {
            this.coordinates.features.push({
              type: 'Feature',
              properties: {},
              geometry: {
                type: 'Point',
                coordinates: [location.position.lng, location.position.lat]
              }
            });
          });

          this.map.addLayer({
            id: 'clusters',
            type: 'circle',
            source: 'xact-markers',
            filter: ['has', 'point_count'],
            paint: {
              // Use step expressions (https://docs.mapbox.com/mapbox-gl-js/style-spec/#expressions-step)
              // with three steps to implement three types of circles:
              //   * Blue, 20px circles when point count is less than 100
              //   * Yellow, 30px circles when point count is between 100 and 750
              //   * Pink, 40px circles when point count is greater than or equal to 750
              'circle-color': [
                'step',
                ['get', 'point_count'],
                '#51bbd6',
                100,
                '#f1f075',
                750,
                '#f28cb1'
              ],
              'circle-radius': [
                'step',
                ['get', 'point_count'],
                20,
                100,
                30,
                750,
                40
              ]
            }
          });

          store.commit(`OverLayModule/${SET_OVERLAY_DISPLAY}`, false);
        }
      });
    } else {
      this.treeViewModelCopy.map(item => {
        if (!this.treeViewModel.includes(item)) {
          this.deleteLocation(parseInt(item.slice(8), 10));
        }
        if (this.treeViewModel.length === 0) {
          store.commit(
            `MarkersFilteringModule/${SET_FILTERING_ELEMENT_DISABLED}`,
            true
          );
          store.commit(
            `MarkersFilteringModule/${CHANGE_SLIDER_MODEL_VALUE}`,
            0
          );
          store.commit(`MarkersFilteringModule/${CHANGE_RADIO_GROUP_TEXT}`, '');
        }
        store.commit(`OverLayModule/${SET_OVERLAY_DISPLAY}`, false);
      });
    }
    this.treeViewModelCopy = this.treeViewModel.slice();
  }

  private async created() {
    console.log(this.map);
    // create load-children
    store.commit(`LocationModule/${CLEAR_TEMPMARKERS}`);
    await this.getCustomers(this.$auth.token);
    await this.getProjects(this.$auth.token);

    this.customers.map(customer => {
      const treeViewItem = {
        id: `Customer ${customer.id}`,
        name: customer.name,
        children: []
      };

      this.projects.map(project => {
        if (project.customerId === customer.id) {
          treeViewItem.children.push({
            id: `Project ${project.id}`,
            name: project.name,
            customerId: customer.id
          });
        }
      });
      this.treeViewItems.push(treeViewItem);
    });
  }
}
